var _mask;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullAttendanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_676_19139",
    maskUnits: "userSpaceOnUse",
    x: 1.91333,
    y: 2.5625,
    width: 21,
    height: 20,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1.91333,
    y: 2.5625,
    width: 21,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3005 3.5625C10.3483 3.5625 8.77624 5.14183 8.77624 7.08676C8.77624 9.03168 10.3556 10.611 12.3005 10.611C14.2454 10.611 15.8247 9.03168 15.8247 7.08676C15.8247 5.14183 14.2454 3.5625 12.3005 3.5625ZM12.3005 11.5542C11.7887 11.5542 11.2257 11.5104 10.5895 11.3934C9.33924 11.1594 8.57882 10.5013 7.05798 10.8011C3.7092 11.4592 0.835692 21.0887 4.93026 21.2203C7.12378 21.2935 8.46183 18.8002 10.1216 18.1494C10.5749 17.9739 11.4523 17.8862 12.2932 17.8862C13.134 17.8862 14.0187 17.9739 14.4648 18.1494C16.1245 18.8075 17.4626 21.2861 19.6561 21.2203C23.758 21.0887 20.8772 11.4592 17.5284 10.8011C16.0075 10.5013 15.2471 11.1594 13.9968 11.3934C13.3607 11.5104 12.7977 11.5542 12.2859 11.5542"
  }))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3005 3.5625C10.3483 3.5625 8.77624 5.14183 8.77624 7.08676C8.77624 9.03168 10.3556 10.611 12.3005 10.611C14.2454 10.611 15.8247 9.03168 15.8247 7.08676C15.8247 5.14183 14.2454 3.5625 12.3005 3.5625ZM12.3005 11.5542C11.7887 11.5542 11.2257 11.5104 10.5895 11.3934C9.33924 11.1594 8.57882 10.5013 7.05798 10.8011C3.7092 11.4592 0.835692 21.0887 4.93026 21.2203C7.12378 21.2935 8.46183 18.8002 10.1216 18.1494C10.5749 17.9739 11.4523 17.8862 12.2932 17.8862C13.134 17.8862 14.0187 17.9739 14.4648 18.1494C16.1245 18.8075 17.4626 21.2861 19.6561 21.2203C23.758 21.0887 20.8772 11.4592 17.5284 10.8011C16.0075 10.5013 15.2471 11.1594 13.9968 11.3934C13.3607 11.5104 12.7977 11.5542 12.2859 11.5542",
    fill: "#77F9E1",
    style: {
      fill: "#77F9E1",
      fill: "color(display-p3 0.4667 0.9765 0.8824)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5895 11.3934L10.4976 11.8848L10.4991 11.8851L10.5895 11.3934ZM7.05798 10.8011L7.15439 11.2917L7.15467 11.2917L7.05798 10.8011ZM4.93026 21.2203L4.94692 20.7206L4.94633 20.7206L4.93026 21.2203ZM10.1216 18.1494L9.9411 17.6831L9.93909 17.6839L10.1216 18.1494ZM14.4648 18.1494L14.649 17.6846L14.6478 17.6841L14.4648 18.1494ZM19.6561 21.2203L19.6711 21.7201L19.6721 21.7201L19.6561 21.2203ZM17.5284 10.8011L17.4317 11.2917L17.432 11.2917L17.5284 10.8011ZM13.9968 11.3934L14.0873 11.8851L14.0888 11.8848L13.9968 11.3934ZM12.3005 3.0625C10.0714 3.0625 8.27624 4.86637 8.27624 7.08676H9.27624C9.27624 5.4173 10.6251 4.0625 12.3005 4.0625V3.0625ZM8.27624 7.08676C8.27624 9.30782 10.0794 11.111 12.3005 11.111V10.111C10.6317 10.111 9.27624 8.75553 9.27624 7.08676H8.27624ZM12.3005 11.111C14.5216 11.111 16.3247 9.30782 16.3247 7.08676H15.3247C15.3247 8.75553 13.9693 10.111 12.3005 10.111V11.111ZM16.3247 7.08676C16.3247 4.86569 14.5216 3.0625 12.3005 3.0625V4.0625C13.9693 4.0625 15.3247 5.41798 15.3247 7.08676H16.3247ZM12.3005 11.0542C11.8182 11.0542 11.2855 11.013 10.68 10.9016L10.4991 11.8851C11.1658 12.0077 11.7591 12.0542 12.3005 12.0542V11.0542ZM10.6815 10.9019C10.4014 10.8495 10.144 10.7725 9.88165 10.6854C9.62972 10.6018 9.34466 10.4985 9.06505 10.417C8.47381 10.2448 7.82011 10.1413 6.96128 10.3106L7.15467 11.2917C7.81668 11.1612 8.30361 11.2368 8.78537 11.3771C9.04226 11.452 9.27679 11.5383 9.56662 11.6345C9.84604 11.7273 10.1526 11.8203 10.4976 11.8848L10.6815 10.9019ZM6.96157 10.3105C5.92711 10.5138 5.02245 11.3763 4.32313 12.4076C3.60994 13.4593 3.04273 14.7843 2.71773 16.0871C2.39513 17.3803 2.29611 18.7127 2.58202 19.7609C2.72654 20.2908 2.97693 20.7744 3.37352 21.1328C3.77685 21.4973 4.2965 21.7002 4.9142 21.7201L4.94633 20.7206C4.54038 20.7075 4.25414 20.5808 4.04397 20.3909C3.82707 20.1949 3.65634 19.8995 3.54678 19.4978C3.32453 18.6829 3.38544 17.542 3.688 16.3292C3.98815 15.1259 4.51131 13.9119 5.15078 12.9689C5.80414 12.0054 6.51446 11.4175 7.15439 11.2917L6.96157 10.3105ZM4.91361 21.7201C6.21376 21.7634 7.22458 21.0406 8.05039 20.3369C8.50125 19.9527 8.83182 19.6337 9.23677 19.2998C9.61697 18.9864 9.96324 18.7486 10.3041 18.6149L9.93909 17.6839C9.45006 17.8756 9.00667 18.1935 8.60063 18.5283C8.21934 18.8426 7.76709 19.2644 7.40178 19.5758C6.59525 20.2631 5.84029 20.7504 4.94692 20.7206L4.91361 21.7201ZM10.3021 18.6157C10.6619 18.4764 11.4577 18.3862 12.2932 18.3862V17.3862C11.447 17.3862 10.488 17.4714 9.9411 17.6831L10.3021 18.6157ZM12.2932 18.3862C12.6977 18.3862 13.1098 18.4074 13.47 18.4487C13.8399 18.4912 14.1205 18.5513 14.2817 18.6147L14.6478 17.6841C14.363 17.5721 13.9783 17.5005 13.5841 17.4553C13.1802 17.4089 12.7295 17.3862 12.2932 17.3862V18.3862ZM14.2805 18.6142C14.6224 18.7498 14.9694 18.9886 15.3497 19.302C15.5381 19.4572 15.7279 19.6248 15.926 19.8011C16.1219 19.9755 16.327 20.1593 16.5365 20.3373C17.3627 21.0396 18.3725 21.7591 19.6711 21.7201L19.6411 20.7206C18.7461 20.7474 17.9902 20.2605 17.1841 19.5753C16.9855 19.4065 16.7908 19.2321 16.5908 19.0541C16.3928 18.878 16.1903 18.6989 15.9856 18.5302C15.5797 18.1958 15.137 17.8781 14.649 17.6846L14.2805 18.6142ZM19.6721 21.7201C20.2905 21.7002 20.8108 21.4974 21.2146 21.1331C21.6118 20.7748 21.8626 20.2911 22.0074 19.7611C22.2937 18.7126 22.1944 17.3802 21.8713 16.087C21.5458 14.7841 20.9779 13.4591 20.2641 12.4074C19.5643 11.3762 18.6592 10.5138 17.6248 10.3105L17.432 11.2917C18.072 11.4175 18.7828 12.0055 19.4367 12.969C20.0767 13.9121 20.6006 15.1261 20.9011 16.3293C21.2041 17.5422 21.2652 18.6829 21.0427 19.4976C20.933 19.8992 20.7621 20.1945 20.5448 20.3906C20.3342 20.5806 20.0472 20.7075 19.6401 20.7206L19.6721 21.7201ZM17.6251 10.3106C16.7662 10.1413 16.1125 10.2448 15.5213 10.417C15.2417 10.4985 14.9566 10.6018 14.7047 10.6854C14.4424 10.7725 14.185 10.8495 13.9048 10.9019L14.0888 11.8848C14.4338 11.8203 14.7403 11.7273 15.0197 11.6345C15.3096 11.5383 15.5441 11.452 15.801 11.3771C16.2827 11.2368 16.7697 11.1612 17.4317 11.2917L17.6251 10.3106ZM13.9064 10.9016C13.3008 11.013 12.7681 11.0542 12.2859 11.0542V12.0542C12.8272 12.0542 13.4205 12.0077 14.0872 11.8851L13.9064 10.9016Z",
    fill: "#02476F",
    style: {
      fill: "#02476F",
      fill: "color(display-p3 0.0078 0.2784 0.4353)",
      fillOpacity: 1
    },
    mask: "url(#path-1-outside-1_676_19139)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2071 14.577C17.2071 14.7133 17.0966 14.8238 16.9603 14.8238C16.8239 14.8238 16.7134 14.7133 16.7134 14.577C16.7134 14.4406 16.8239 14.3301 16.9603 14.3301C17.0966 14.3301 17.2071 14.4406 17.2071 14.577Z",
    fill: "#50D5BC",
    style: {
      fill: "#50D5BC",
      fill: "color(display-p3 0.3125 0.8333 0.7392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2074 15.5633C17.2074 15.6996 17.0969 15.8102 16.9605 15.8102C16.8242 15.8102 16.7136 15.6996 16.7136 15.5633C16.7136 15.4269 16.8242 15.3164 16.9605 15.3164C17.0969 15.3164 17.2074 15.4269 17.2074 15.5633Z",
    fill: "#50D5BC",
    style: {
      fill: "#50D5BC",
      fill: "color(display-p3 0.3125 0.8333 0.7392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2198 16.5516C16.2198 16.6879 16.1093 16.7984 15.973 16.7984C15.8366 16.7984 15.7261 16.6879 15.7261 16.5516C15.7261 16.4152 15.8366 16.3047 15.973 16.3047C16.1093 16.3047 16.2198 16.4152 16.2198 16.5516Z",
    fill: "#50D5BC",
    style: {
      fill: "#50D5BC",
      fill: "color(display-p3 0.3125 0.8333 0.7392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4791 17.5398C15.4791 17.6762 15.3686 17.7867 15.2322 17.7867C15.0959 17.7867 14.9854 17.6762 14.9854 17.5398C14.9854 17.4035 15.0959 17.293 15.2322 17.293C15.3686 17.293 15.4791 17.4035 15.4791 17.5398Z",
    fill: "#50D5BC",
    style: {
      fill: "#50D5BC",
      fill: "color(display-p3 0.3125 0.8333 0.7392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9728 13.8357C15.9728 13.9721 15.8622 14.0826 15.7259 14.0826C15.5895 14.0826 15.479 13.9721 15.479 13.8357C15.479 13.6994 15.5895 13.5889 15.7259 13.5889C15.8622 13.5889 15.9728 13.6994 15.9728 13.8357Z",
    fill: "#50D5BC",
    style: {
      fill: "#50D5BC",
      fill: "color(display-p3 0.3125 0.8333 0.7392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4418 13.0955C18.4418 13.2319 18.3312 13.3424 18.1949 13.3424C18.0585 13.3424 17.948 13.2319 17.948 13.0955C17.948 12.9592 18.0585 12.8486 18.1949 12.8486C18.3312 12.8486 18.4418 12.9592 18.4418 13.0955Z",
    fill: "#50D5BC",
    style: {
      fill: "#50D5BC",
      fill: "color(display-p3 0.3125 0.8333 0.7392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2072 13.219C17.2072 13.4235 17.0414 13.5893 16.8369 13.5893C16.6324 13.5893 16.4666 13.4235 16.4666 13.219C16.4666 13.0144 16.6324 12.8486 16.8369 12.8486C17.0414 12.8486 17.2072 13.0144 17.2072 13.219Z",
    fill: "#50D5BC",
    style: {
      fill: "#50D5BC",
      fill: "color(display-p3 0.3125 0.8333 0.7392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2196 15.4406C16.2196 15.6452 16.0538 15.811 15.8493 15.811C15.6448 15.811 15.479 15.6452 15.479 15.4406C15.479 15.2361 15.6448 15.0703 15.8493 15.0703C16.0538 15.0703 16.2196 15.2361 16.2196 15.4406Z",
    fill: "#50D5BC",
    style: {
      fill: "#50D5BC",
      fill: "color(display-p3 0.3125 0.8333 0.7392)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01363 18.7897C8.47899 17.9878 10.7134 13.5168 11.8509 11.5407C10.9991 11.5568 9.56757 11.1317 8.95316 10.8965C5.48466 11.5999 4.68586 18.0323 4.72003 21.1606C5.3521 21.5029 6.89867 20.7148 7.22238 20.3702C7.48134 20.0945 8.47064 19.2386 9.01363 18.7897Z",
    fill: "#7AEED9",
    style: {
      fill: "#7AEED9",
      fill: "color(display-p3 0.4783 0.9333 0.8509)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1115 11.2713C6.66623 11.3913 5.04306 17.9413 4.71937 21.1764C2.44816 21.3522 2.43372 18.0387 3.31254 15.4836C4.19137 12.9285 5.33044 11.7955 5.96906 11.1991C6.60768 10.6027 7.37825 10.6713 7.98521 10.6713C8.47077 10.6713 9.33242 11.0265 10.1115 11.2713Z",
    fill: "#30CFC6",
    style: {
      fill: "#30CFC6",
      fill: "color(display-p3 0.1882 0.8118 0.7765)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8495 7.09123C15.8495 9.04009 14.2696 10.62 12.3207 10.62C10.3719 10.62 8.79199 9.04009 8.79199 7.09123C8.79199 5.14237 10.3719 3.5625 12.3207 3.5625C14.2696 3.5625 15.8495 5.14237 15.8495 7.09123Z",
    fill: "#84F8E3",
    style: {
      fill: "#84F8E3",
      fill: "color(display-p3 0.5176 0.9725 0.8902)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6319 5.86871C15.0462 5.23935 14.2106 4.84569 13.2831 4.84569C11.5114 4.84569 10.0752 6.28192 10.0752 8.05361C10.0752 8.98114 10.4688 9.81673 11.0982 10.4024C9.75186 9.90517 8.79199 8.61029 8.79199 7.09123C8.79199 5.14237 10.3719 3.5625 12.3207 3.5625C13.8398 3.5625 15.1347 4.52239 15.6319 5.86871Z",
    fill: "#30CFC6",
    style: {
      fill: "#30CFC6",
      fill: "color(display-p3 0.1882 0.8118 0.7765)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5663 8.73008C12.6452 9.01918 13.7929 8.35045 14.1037 7.19057C14.1757 6.92165 14.4521 6.76206 14.7211 6.83412C14.99 6.90618 15.1496 7.1826 15.0775 7.45152C14.6313 9.11674 12.9541 10.1457 11.3053 9.70393C11.0364 9.63188 10.8768 9.35546 10.9489 9.08653C11.0209 8.81761 11.2974 8.65802 11.5663 8.73008Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04419 13.8348C5.39536 13.0231 6.37902 11.2603 7.83989 11.3353",
    stroke: "white",
    style: {
      stroke: "white",
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.507609,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullAttendanceIcon);
export default __webpack_public_path__ + "static/media/full-attendance-icon.a88b0edfaed69ed7c687832a9cac70dc06dcb14245c2a98be05e1030f388a9da.svg";
export { ForwardRef as ReactComponent };